import * as React from 'react'

import { cva } from 'class-variance-authority'

import { cn } from '@/utils/shadcn'

import type { VariantProps } from 'class-variance-authority'

const buttonVariants = cva(
  'inline-flex items-center justify-center rounded-md text-sm font-medium transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:opacity-50 disabled:pointer-events-none ring-offset-background',
  {
    variants: {
      variant: {
        default: 'bg-primary text-primary-foreground hover:bg-primary/90',
        destructive:
          'bg-destructive text-destructive-foreground hover:bg-destructive/90',
        outline:
          'border border-input hover:bg-accent hover:text-accent-foreground',
        secondary:
          'bg-white text-black hover:bg-white/80 border border-input',
        ghost: 'hover:bg-accent hover:text-accent-foreground',
        invisible: 'hover:bg-transparent hover:text-accent-foreground',
        link: 'underline-offset-4 hover:underline text-primary',
      },
      size: {
        default: 'h-10 py-2 px-4',
        sm: 'h-9 px-3 rounded-md',
        lg: 'h-11 px-8 rounded-md',
        icon: 'h-7 px-2 rounded-md',
        xs: 'h-9 px-0 rounded-md',
      },
      padded: {
        normal: '',
        clean: 'px-0 py-0',
      },
    },
    defaultVariants: {
      variant: 'default',
      size: 'default',
    },
  }
)

export interface ButtonProps
  extends React.ButtonHTMLAttributes<HTMLButtonElement>,
    VariantProps<typeof buttonVariants> {
      padded?: 'normal' | 'clean'
    }

const Button = React.forwardRef<HTMLButtonElement, ButtonProps>(
  ({ className, variant, size, padded,...props }, ref) => {
    return (
      <button
        className={`${cn(
          buttonVariants({
            variant,
            size,
            padded: padded || 'normal',
            className: `${className} transition-all active:scale-95`,
          })
        )} `}
        ref={ref}
        {...props}
      />
    )
  }
)
Button.displayName = 'Button'

export { Button, buttonVariants }
